export default __webpack_public_path__ + "static/media/ContentLibraryLightActive.6769e2d7.svg";